import React, { useEffect, useState } from "react";
//
import "./layout.scss";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import ContactForm from "../blocks/contactForm/contactForm";
import Loader from "components/loader/loader";
import TransLayer from "components/trans/transLayer";
import CookieNotice from "components/cookieNotice/cookieNotice";
import useWinHeight from "hooks/utils/useWinHeight";
import { useLocation } from "@reach/router";

interface Props {
  pageContext: {
    slug: string;
  };
}

const Layout: React.FC<Props> = (props) => {
  const [loaderComplete, setLoaderComplete] = useState<boolean>(false);
  useWinHeight();
  const location = useLocation();

  useEffect(() => {
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="layout">
      <Loader onComplete={() => setLoaderComplete(true)} />
      <Header stageLoaded={loaderComplete} />
      <TransLayer />
      <main className="layout-main">{loaderComplete && props.children}</main>
      {props.pageContext.slug !== "contact" && <ContactForm isFooterLayout />}
      <Footer />
      <CookieNotice />
    </div>
  );
};

export default Layout;
